import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import { SearchInput } from '../../components/Form';
import { MonthDayPicker } from '../../components/Date/MonthDayPicker';
import Button from '../../components/Button/Button';
import { FilterBarProps } from '../../components/FilterBar/FilterBar';
import { getStringSearchPlaceholder } from '../../helpers/search';
import ReactSelect from '../../components/ReactSelect';

const stringSearchFields = [
  {
    field: 'title',
    label: 'Title',
  },
  {
    field: 'body',
    label: 'Body',
  },
] as const;

export type ActivityReadFilter = 'ALL' | 'UNREAD' | 'DISMISSED';

export type ActivityFilters = {
  stringSearch?: string;
  readFilter?: ActivityReadFilter;
  dateStart?: string;
  dateEnd?: string;
};

export const defaultFilters: ActivityFilters = {
  readFilter: 'ALL',
};

const readFilterOptions = [
  { value: 'ALL', label: 'All visible' },
  { value: 'UNREAD', label: 'Unread' },
  { value: 'DISMISSED', label: 'Cleared' },
] as const;

type FilterBarActivityProps = FilterBarProps<ActivityFilters>;

const FilterBarActivity: React.FC<FilterBarActivityProps> = (props) => {
  const { filters, setFilters } = props;

  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          width={320}
          name="stringSearch"
          value={filters.stringSearch || ''}
          onChange={(e) => {
            setFilters((prevState) => ({
              ...prevState,
              stringSearch: e.target.value,
            }));
          }}
        />
        <ReactSelect
          placeholder="activity"
          isClearable={false}
          value={readFilterOptions.find(
            (option) => option.value === (filters.readFilter || 'ALL')
          )}
          onChange={(option) => {
            setFilters((prevState) => ({
              ...prevState,
              readFilter: option?.value ?? 'ALL',
            }));
          }}
          options={readFilterOptions}
          styles={{
            container: (base) => ({
              ...base,
              width: 170,
            }),
          }}
        />
        <MonthDayPicker
          startDate={filters.dateStart}
          endDate={filters.dateEnd}
          variant="input"
          onChange={(dateStart, dateEnd) => {
            setFilters((prevState) => ({
              ...prevState,
              dateStart: dateStart ?? undefined,
              dateEnd: dateEnd ?? undefined,
            }));
          }}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => setFilters(defaultFilters)}
          title="Reset Filters"
        />
      </Flex>
    </Flex>
  );
};

FilterBarActivity.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarActivity;
